import { MemberRole } from 'src/api/circles';
import { useAppDispatch } from 'src/hooks/Redux/useAppDispatch';
import useAppSelector from 'src/hooks/Redux/useAppSelector';
import {
  selectCurrentUser,
  selectRoleViewOverride,
  selectTribeDetails,
  setRoleViewOverride,
} from 'src/redux/slices/loggedUserSlice';

const ROLE_VIEW_EMAILS = ['ole@dunbar148.com', 'markus@dunbar148.com'];
const ROLE_VIEW_NAMES = ['ole jørgen reierstad'];

export const canUseCircleRoleView = (
  email?: string | null,
  fullName?: string | null
): boolean =>
  ROLE_VIEW_EMAILS.includes((email ?? '').trim().toLowerCase()) ||
  ROLE_VIEW_NAMES.includes((fullName ?? '').trim().toLowerCase());

export const useCircleRoleView = (circleId?: string) => {
  const dispatch = useAppDispatch();
  const user = useAppSelector(selectCurrentUser);
  const tribeDetails = useAppSelector(selectTribeDetails);
  const override = useAppSelector(selectRoleViewOverride);

  const canToggle = canUseCircleRoleView(user?.email, user?.full_name);
  const myRole = tribeDetails?.find((t) => t._id === circleId)?.role;
  const actualIsLeader =
    myRole === MemberRole.Leader || myRole === MemberRole.CoLeader;
  const isLeader = canToggle
    ? override === 'member'
      ? false
      : override === 'leader'
        ? true
        : actualIsLeader
    : actualIsLeader;

  const setViewAs = (view: 'leader' | 'member') => {
    if (!canToggle) {
      return;
    }
    dispatch(setRoleViewOverride(view));
  };

  const toggleView = () => {
    setViewAs(isLeader ? 'member' : 'leader');
  };

  return {
    isLeader,
    actualIsLeader,
    canToggle,
    viewAs: isLeader ? 'leader' : 'member',
    setViewAs,
    toggleView,
  };
};
